module.exports = "<sa-header></sa-header>\n\n\n<sa-navigation></sa-navigation>\n\n\n<div id=\"main\" role=\"main\">\n  <!--<sa-layout-switcher></sa-layout-switcher>-->\n\n  <sa-ribbon></sa-ribbon>\n\n  <router-outlet></router-outlet>\n</div>\n\n<sa-footer></sa-footer>\n\n<!--<sa-shortcut></sa-shortcut>-->\n"


//////////////////
// WEBPACK FOOTER
// /Users/alex/Documents/JC/JC3 3/src/app/shared/layout/app-layouts/main-layout.component.html
// module id = ../../../../../src/app/shared/layout/app-layouts/main-layout.component.html
// module chunks = main